const nannyCaretakerDetailedRateCard = {
  key: "nanny-caretaker",
  title: "Nanny / Care-taker Detailed Rate Card",
  note:
    "Indicative care support pricing. Final rates vary by care hours, child age, elder support level, recurring requirement, and city.",
  sections: [
    {
      title: "Child Care",
      items: [
        { name: "Child care - 4 hour shift", price: "₹699 onwards" },
        { name: "Child care - full day", price: "₹1499 onwards" },
      ],
    },
    {
      title: "Care Support",
      items: [
        { name: "Elder care visit support", price: "₹799 onwards" },
        { name: "Recurring caretaker plan", price: "₹4999 onwards monthly" },
      ],
    },
    {
      title: "Consultation",
      items: [
        { name: "Recurring care requirement consultation", price: "₹299" },
      ],
    },
  ],
};

export default nannyCaretakerDetailedRateCard;